<template>
<file-layout @download="onDownload" :file-name="fileName" :show-header="isPublic" :can-download="isPublic" :allow-share="false">
    <div id="cloud_disk_video_file"></div>
    <div class="error_wrap" v-if="!isLoadSuccess">
        <div class="error_text">{{$t("加载失败，请#!!!#src/pages/H5/Cloud/components/VideoView.vue_1")}}<span class="retry_btn" @click="retryLoad">{{$t("重试#!!!#src/pages/H5/Cloud/components/VideoView.vue_1")}}</span></div>
    </div>
  </file-layout>
</template>

<script>
import FileLayout from "@/components/h5/Layout";
import Player from "xgplayer";
import "xgplayer/dist/index.min.css";
import PlayerRatePlugin from "../utils/PlayerRatePlugin";
import { getBrowser } from "../utils/browser";

export default {
  props: {
    rootId: {
      type: String,
    },
    fileId: {
      type: String,
    },
    metadata: {
      type: Object,
    },
    isPublic: {
      type: Boolean,
    },
    sharePassword: {
      type: String,
      default: "",
    },
  },
  components: {
    FileLayout,
  },
  data() {
    return {
      player: null,
      isLoadSuccess: true,
    };
  },
  methods: {
    getLink() {
      const pass = this.sharePassword || "";
      const inner = `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD_URL}/file/preview/other/${this.fileId}`;
      const outer = `${process.env.VUE_APP_NEW_STREAM_DOWNLOAD_URL}/public/preview/${this.fileId}?rootId=${this.rootId}&password=${pass}&isPreview=true`;
      return this.isPublic ? outer : inner;
    },
    loadXGPlayer(){
        try{
            const link = this.getLink();
            this.player = new Player({
                id: "cloud_disk_video_file",
                url: link,
                height: "100%",
                width: "100%",
                autoplay: true,
                videoInit: true,
                fitVideoSize: "fixed",
                plugins: this.isMobile === true ? [PlayerRatePlugin] : [],
                playbackRate: this.isMobile === true ? false : [0.5, 0.75, 1, 1.5, 2],
            });
            setTimeout(() => {
                try {
                    const $video = document.getElementsByTagName("video")[0];
                    $video.setAttribute("playsinline", "true");
                    $video.setAttribute("webkit-playsinline", "true");
                    $video.setAttribute("x5-video-player-fullscreen", "true");
                    $video.setAttribute("x5-playsinline", "true");
                } catch (er) {}
            }, 0);
        }catch(err){
            this.isLoadSuccess = false;
        }
    },
    retryLoad() {
        this.isLoadSuccess = true;
        this.loadXGPlayer();
    },
    onDownload() {
      this.$emit("download", this.fileId);
    },
  },
  computed: {
    fileName() {
      return this.metadata ? this.metadata?.fileName : "";
    },
    isMobile() {
      const browser = getBrowser();
      return browser.isMobile;
    },
  },
  mounted() {
    this.loadXGPlayer();
  },
};
</script>

<style lang="scss" scoped>
.error_wrap {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .error_text {
        white-space: wrap;
        color: #a2a4b0;
        font-size: 14px;
        font-weight: 400;
        max-width: 80%;
        letter-spacing: 0;
        text-align: center;

        span {
            cursor: pointer;
            color: #5c70ff;
        }
    }
}
</style>

<style lang="scss">
#cloud_disk_video_file {
  max-width: 100%;
  max-height: 100%;
  width: 100% !important;
  height: 100% !important;

  video {
    width: 100% !important;
    height: 100% !important;
  }

  .xgplayer-controls {
    bottom: 48px !important;
  }
}
</style>
